import { Box, createStyles, makeStyles } from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import { TranquiTheme } from '../../../containers/App/theme';
import useDictionary from '../../../dictionaries/context/useDictionary';
import { NegotiationOption, NegotiationOptionAlternative, OutDebt } from '../../../generated/graphql';
import Collapse from '../../Collapse/Collapse';
import ACPKDebtsSummaryTable from '../../NegotiationDebts/ACPKDebtsSummaryTable';
import NewPaymentTerms from './NewPaymentTerms';
import SelectAlternative from './SelectAlternative';

interface NewPaymentTermsWithAlternativeProps {
  debt: OutDebt;
  isSelected?: boolean;
  selectedOption: NegotiationOption | null;
  selectedAlternative: NegotiationOptionAlternative | null;
  onPreConfirmAlternative: () => void;
  setSelectedAlternative: React.Dispatch<React.SetStateAction<NegotiationOptionAlternative | null>>;
  className?: string;
  onChangeSelectedOption?: (option: Pick<NegotiationOption, 'type'>) => void;
}

const NewPaymentTermsWithAlternative: React.FC<NewPaymentTermsWithAlternativeProps> = (props) => {
  const { debt,
    selectedAlternative, selectedOption,
    onPreConfirmAlternative, className,
    setSelectedAlternative,
    isSelected,
    onChangeSelectedOption,
  } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const { gT } = useDictionary();

  if (!selectedOption) return null;

  return (
    <Box className={cn(classes.box, className)}>
      <ACPKDebtsSummaryTable
        className={classes.summaryTable}
        debt={debt}
        withBackground
        title={gT('acpk_multi_table_title')}
      />

      <SelectAlternative
        autoSelect={isSelected}
        debt={debt}
        alternatives={selectedOption?.alternatives}
        negOption={selectedOption}
        selectedAlternative={selectedAlternative}
        setSelectedAlternative={setSelectedAlternative}
        onChangeSelectedOption={onChangeSelectedOption}
      />
      <Collapse in={!!selectedAlternative}>
        <NewPaymentTerms
          negOption={selectedOption}
          alternative={selectedAlternative || undefined}
          onConfirm={onPreConfirmAlternative}
          outDebt={debt}
        />
      </Collapse>
    </Box>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  box: {
    width: '100%',
    backgroundColor: theme.palette.marble.main,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
  summaryTable: {
    margin: theme.spacing(0, 2),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 0, 2),
    },
  },
}));

export default NewPaymentTermsWithAlternative;
